import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SITE_URL, SITE_NAME, OG_IMAGE, isNoIndexPath } from '../../data/seo';
import { useCatalog } from '../../contexts/CatalogContext';
import { clampDescription } from './seoText';
import { businessSchema } from './schemas';
import { resolveSeo } from './resolveSeo';
import { upsertJsonLd, upsertLink, upsertMeta } from '../../ui/headTags';

/** Zet title, meta, canonical, Open Graph en structured data per route. */
export function Seo() {
  const {
    pathname
  } = useLocation();
  const catalog = useCatalog();
  useEffect(() => {
    const url = `${SITE_URL}${pathname === '/' ? '' : pathname}`;
    const {
      entry,
      schema,
      faq,
      type,
      image,
      notFound
    } = resolveSeo(pathname, url, catalog);
    const noIndex = notFound || isNoIndexPath(pathname);
    const description = clampDescription(entry.description);
    const ogImage = image ?? OG_IMAGE;
    document.documentElement.lang = 'nl';
    document.title = entry.title;
    upsertMeta('name', 'robots', noIndex ? 'noindex, nofollow' : 'index, follow');
    upsertMeta('name', 'description', description);
    upsertMeta('name', 'keywords', entry.keywords.join(', '));
    upsertMeta('property', 'og:title', entry.title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', url);
    // og:type "product" is geen officieel OG-type; "website" is de veilige keuze voor producten.
    upsertMeta('property', 'og:type', type === 'article' ? 'article' : 'website');
    upsertMeta('property', 'og:image', ogImage);
    upsertMeta('property', 'og:locale', 'nl_NL');
    upsertMeta('property', 'og:site_name', SITE_NAME);
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', entry.title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', ogImage);
    upsertLink('canonical', url);
    upsertJsonLd('ld-business', businessSchema());
    upsertJsonLd('ld-page', schema);
    upsertJsonLd('ld-faq', faq);
  }, [pathname, catalog]);
  return null;
}